/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService
 */

export const getAccessControlsRpc = {
  serviceName: 'com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService',
  rpcName: 'getAccessControls',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA0CKhPg64o3kQ8wsYnf1uS',
  na1Only: false
};
export const patchAccessControlsRpc = {
  serviceName: 'com.hubspot.ai.access.controls.rpc.AiAccessControlsChirpService',
  rpcName: 'patchAccessControls',
  auth: 'app',
  fingerprint: '7dCs4jF6dtEWkXRcfWapVkQ8wsYnf1uS',
  na1Only: false
};